import { z } from 'zod'
import { type QuickMdState } from '@/app/store'
import { useAppSelector } from '@/redux/hooks/useAppSelector'
import { profilePermissions } from '@/utils/constants'

/**
 * The logged-in admin's profile (`GET /api/v1/profile`) is stored untyped in the
 * legacy Redux slice, so we narrow the only field we care about at the boundary.
 */
const ProfilePermissionsSchema = z.object({
  Permissions: z.array(z.string()).nullish(),
})

const selectAdminProfile = (state: QuickMdState) => state.accountSettings.adminProfile

/**
 * True when the logged-in admin holds `visit.medicalrecords.delete` — the permission the
 * backend requires to delete a visit's clinical notes or patient instructions (QMD-4537).
 * The API is the source of truth (403 Permission); this gates the UI affordance so a staff
 * member without it never sees the delete action.
 */
export function useCanDeleteMedicalRecords(): boolean {
  const adminProfile = useAppSelector(selectAdminProfile)
  const result = ProfilePermissionsSchema.safeParse(adminProfile)
  if (!result.success) return false
  return result.data.Permissions?.includes(profilePermissions.DELETE_MEDICAL_RECORDS) ?? false
}
